import { apiRequest } from "./client";
import { normalizeListPayload } from "../utils/pagination";

const toQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, value);
  });
  const value = search.toString();
  return value ? `?${value}` : "";
};

const normalizeStatus = (status) => {
  if (status === true || status === 1 || status === "1") return "active";
  if (status === false || status === 0 || status === "0") return "inactive";
  if (status === "active" || status === "inactive" || status === "invited") return status;
  return "inactive";
};

const normalizeUser = (user = {}) => ({
  ...user,
  status: normalizeStatus(user.status),
  role_name: user.role_name || user.job_title || "Administrator",
  phone: user.phone || "",
  last_active: user.last_active || user.last_login_at || user.last_login || null,
});

export const fetchAdminUsers = async (params = {}) => {
  const payload = await apiRequest(
    `/admin-users${toQuery({
      page: 1,
      per_page: 20,
      sort_by: "created_at",
      sort_order: "desc",
      ...params,
    })}`
  );

  const { items, meta } = normalizeListPayload(payload, {
    itemKeys: ["users"],
    perPage: params.per_page,
  });
  const users = items.map(normalizeUser);
  const body = payload?.data && !Array.isArray(payload.data) ? payload.data : payload;

  const summary = body?.summary || {
    total: meta.total,
    active: users.filter((user) => user.status === "active").length,
    inactive: users.filter((user) => user.status === "inactive").length,
    invited: users.filter((user) => user.status === "invited").length,
  };

  return { users, meta, summary };
};

export const createAdminUser = async (user) =>
  (await apiRequest("/admin-users", { method: "POST", body: JSON.stringify(user) })).data;

export const updateAdminUser = async (id, user) =>
  (await apiRequest(`/admin-users/${id}`, { method: "PUT", body: JSON.stringify(user) })).data;

export const resendAdminInvitation = async (id) =>
  (await apiRequest(`/admin-users/${id}/resend-invitation`, { method: "POST" })).data;

export const deleteAdminUser = async (id) => apiRequest(`/admin-users/${id}`, { method: "DELETE" });
